(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["af-gift-note"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('af-gift-note')) {
  class AFGiftNote extends HTMLElement {
    static instances = new Set();
    static state = null;
    static timer = null;
    static queue = Promise.resolve();
    static revision = 0;
    static savedRevision = 0;
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.toggle = this.querySelector('[data-gift-toggle]');
      this.value = this.querySelector('[data-gift-value]');
      this.message = this.querySelector('[data-gift-message]');
      this.messageValue = this.querySelector('[data-gift-message-value]');
      this.panel = this.querySelector('[data-gift-panel]');
      this.count = this.querySelector('[data-gift-count]');
      this.status = this.querySelector('[data-gift-status]');
      if (!AFGiftNote.state) {
        AFGiftNote.state = { gift: this.toggle.checked, message: this.message.value };
      }
      AFGiftNote.instances.add(this);
      this.renderState();
      const options = { signal: this.controller.signal };
      this.toggle.addEventListener('change', () => this.changed(), options);
      this.message.addEventListener('input', () => this.changed(), options);
      this.form = this.closest('form');
      this.form.addEventListener('submit', async event => {
        if (this.allowSubmit || AFGiftNote.revision === AFGiftNote.savedRevision) return;
        event.preventDefault();
        clearTimeout(AFGiftNote.timer);
        const submitter = event.submitter;
        try {
          await AFGiftNote.save();
          this.allowSubmit = true;
          this.form.requestSubmit(submitter);
          this.allowSubmit = false;
        } catch {
          this.status.hidden = false;
        }
      }, { ...options, capture: true });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      AFGiftNote.instances.delete(this);
    }
    changed() {
      AFGiftNote.state = { gift: this.toggle.checked, message: this.message.value };
      AFGiftNote.revision += 1;
      AFGiftNote.instances.forEach(instance => instance.renderState());
      clearTimeout(AFGiftNote.timer);
      AFGiftNote.timer = setTimeout(() => AFGiftNote.save().catch(() => {}), 300);
    }
    renderState() {
      const state = AFGiftNote.state;
      this.toggle.checked = state.gift;
      this.toggle.setAttribute('aria-expanded', String(state.gift));
      this.value.value = state.gift ? 'Yes' : 'No';
      if (this.message.value !== state.message) this.message.value = state.message;
      this.messageValue.value = state.gift ? state.message : '';
      this.panel.hidden = !state.gift;
      this.count.textContent = state.message.length;
      this.status.hidden = true;
    }
    static save() {
      const revision = this.revision;
      const state = { ...this.state };
      this.queue = this.queue.catch(() => {}).then(async () => {
        if (revision <= this.savedRevision) return;
        try {
          const response = await fetch(Shopify.routes.cart_update + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: {
              'Giving this as a gift': state.gift ? 'Yes' : 'No',
              'Gift message': state.gift ? state.message : ''
            } })
          });
          if (!response.ok) throw new Error('Gift details were not saved');
          this.savedRevision = revision;
          this.instances.forEach(instance => { instance.status.hidden = true; });
        } catch (error) {
          this.instances.forEach(instance => { instance.status.hidden = false; });
          throw error;
        }
      });
      return this.queue;
    }
  }
  customElements.define('af-gift-note', AFGiftNote);
}
  } catch(e) { console.error(e); }
})();

})();
